import FieldEditor from "editor/FieldEditor";
import Flatpickr from "flatpickr";
import FieldEditorText from "./FieldEditorText";


class FieldEditorDate extends FieldEditorText {

    create() {
        super.create();

        this.picker = new Flatpickr(this.$input[0], {
            static: true,
            altInput: this.settings.dateFormat !== null,
            altFormat: this.settings.dateFormat !== null ? this.settings.dateFormat : "Y-m-d",
            dateFormat: "Y-m-d",
            "locale": {
                "firstDayOfWeek": 1, // start week on Monday
            },
            animate: false,
            minDate: this.settings.minDate !== null ? this.settings.minDate : undefined,
            maxDate: this.settings.maxDate !== null ? this.settings.maxDate : undefined,
        });

        if (this.settings.optional) {
            this.$element.addClass("admin-form__input-wrap").append(
                eotwJSXFactory('button', {type: "button", className: "admin-clear-icon js-clear-date"}),
            );

            this.$element.on("click", ".js-clear-date", () => {
                this.picker.clear();
                return false;
            });
        }

        FieldEditorDate.fix_validation_issues(this.picker);

        this.$input.addClass("admin-editor--date");

        if (this.value) {
            this.setValue(this.value);
        }
    }

    setValue(value) {
        if (!this.picker) {
            this.value = value;
            return;
        }
        if ("object" === typeof value && value !== null) {
            this.picker.setDate(new Date(value.timestamp * 1000));
        } else {
            this.picker.setDate(value);
        }
    }

    destroy() {
        let value = this.getValue();
        let displayValue = value;
        if (this.settings.dateFormat && value) {
            displayValue = this.picker.formatDate(new Date(value), this.settings.dateFormat);
        }

        this.picker.destroy();

        super.destroy();
        this.$element.text(displayValue);
    }

    getDefaultSettings() {
        return Object.assign({
            dateFormat: null,
        }, super.getDefaultSettings());
    }

    /**
     * Disable validation for utility inputs within the datepicker
     *
     * @param {Flatpickr} picker
     */
    static fix_validation_issues(picker) {
        if (picker.altInput) {
            $(picker.altInput).addClass("js-no-validate");
        }
        $(picker.calendarContainer).find("input").addClass("js-no-validate");
        $(picker.input).attr("data-has-message", true);
    }
}

FieldEditor.register_editor("date", FieldEditorDate);

export default FieldEditorDate;
